import { Flex, Tabs } from "@mantine/core";
import RegistrationSummary from "../components/Registrations/Overview";
import RegistrationsTable from "../components/Registrations/Table";
import { useContext, useMemo, useState } from "react";
import { AuthContext } from "../services/context";
import { getCurrentWorkspace } from "../services/userConfig";
import {
  IconExternalLink,
  IconListDetails,
  IconHistory,
} from "@tabler/icons-react";
import { openExportModal } from "../components/Registrations/ExportModal";
import { useSetActionButtons } from "../services/ActionButtonsContext";
import History from "../components/Registrations/History";
import { useGetEvent } from "../api/event";
import { useGetRegistrationsOverview } from "../api/registrations";
import AttendeeLimitBanner from "../components/AttendeeLimitBanner";

function RegistrationsOverview() {
  const { user } = useContext(AuthContext);
  const [activeTab, setActiveTab] = useState("overview");
  const [selectedRegistrationId, setSelectedRegistrationId] = useState(null);

  const currentEventId = getCurrentWorkspace(user).eventId;
  const currentEvent = user.events.find((event) => event.id === currentEventId);

  const { data: event, isPending } = useGetEvent(currentEventId);

  const { data: overview, isPending: isOverviewPending } =
    useGetRegistrationsOverview({
      eventId: currentEventId,
    });

  const actions = useMemo(
    () =>
      [
        activeTab === "overview" &&
          currentEvent?.name && {
            label: "Export",
            icon: <IconExternalLink />,
            onClick: () => {
              openExportModal(currentEventId);
            },
          },
      ].filter(Boolean),
    [currentEventId, currentEvent?.name, activeTab]
  );

  useSetActionButtons(actions);

  const handleRegistrationClick = (registrationId) => {
    setSelectedRegistrationId(registrationId);
    setActiveTab("overview");
  };

  if (isPending || isOverviewPending || !event) {
    return null;
  }

  return (
    <Tabs
      value={activeTab}
      onChange={setActiveTab}
      keepMounted={true}
      variant="outline"
    >
      <Tabs.List>
        <Tabs.Tab value="overview" leftSection={<IconListDetails size={16} />}>
          Overview
        </Tabs.Tab>

        <Tabs.Tab value="history" leftSection={<IconHistory size={16} />}>
          History
        </Tabs.Tab>
      </Tabs.List>

      <Tabs.Panel value="overview" style={{ flex: 1 }}>
        <Flex direction="column" grow={1} style={{ overflowY: "auto" }}>
          <AttendeeLimitBanner
            attendeeLimit={event?.attendeeLimit}
            ticketsCount={event?.ticketsCount}
            isAttendeeLimitReached={event?.isAttendeeLimitReached}
            isHardBlocked={event?.isHardBlocked}
          />
          <RegistrationSummary data={overview} isPending={isOverviewPending} />
          <RegistrationsTable
            selectedRegistrationId={selectedRegistrationId}
            onRegistrationSelect={() => setSelectedRegistrationId(null)}
            isHardBlocked={event?.isHardBlocked}
          />
        </Flex>
      </Tabs.Panel>

      <Tabs.Panel value="history" style={{ flex: 1 }}>
        <History
          eventId={currentEventId}
          onRegistrationClick={handleRegistrationClick}
        />
      </Tabs.Panel>
    </Tabs>
  );
}

export default RegistrationsOverview;
